(() => {
  const badgeTypes = ['new', 'sale', 'popular', 'premium'];
  const menus = [...document.querySelectorAll('[data-menu-badges-menu]')];
  if (!menus.length) return;
  const primaryLocale = menus[0].dataset.menuBadgesPrimary.toLowerCase();
  if (menus[0].dataset.menuBadgesLocale.toLowerCase() === primaryLocale) return;
  const requestUrl = new URL(menus[0].dataset.menuBadgesPrimaryRoot, window.location.origin);
  requestUrl.searchParams.set('section_id', menus[0].dataset.menuBadgesSection);
  requestUrl.searchParams.set('locale', primaryLocale);
  const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (previewTheme) requestUrl.searchParams.set('preview_theme_id', previewTheme);

  fetch(requestUrl, { credentials: 'same-origin' })
    .then(response => {
      if (!response.ok) throw new Error('Menu badge source unavailable');
      return response.text();
    })
    .then(html => {
      const source = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('[data-menu-badges-menu]').forEach(menu => {
        const sourceMenu = [...source.querySelectorAll('[data-menu-badges-menu]')]
          .find(candidate => candidate.dataset.menuBadgesMenu === menu.dataset.menuBadgesMenu
            && candidate.dataset.menuBadgesLocale.toLowerCase() === primaryLocale);
        if (!sourceMenu) return;
        const items = new Map([...sourceMenu.querySelectorAll('[data-menu-badge-path]')]
          .map(label => [label.dataset.menuBadgePath, label.dataset]));
        menu.querySelectorAll('[data-menu-badge-path]').forEach(label => {
          const item = items.get(label.dataset.menuBadgePath);
          if (!item || item.menuBadgeResource !== label.dataset.menuBadgeResource) return;
          const manualBadge = badgeTypes.includes(item.menuBadgeManual) ? item.menuBadgeManual : '';
          const badgeType = manualBadge;
          let badge = label.querySelector('[data-menu-badge-type]');
          label.dataset.menuBadgeManual = manualBadge;
          if (!badgeType) {
            if (badge) badge.remove();
            return;
          }
          if (!badge) {
            badge = document.createElement('span');
            const text = document.createElement('span');
            text.className = 'menu-link__badge-text';
            badge.append(text);
            label.append(badge);
          }
          badge.className = 'menu-link__badge menu-link__badge--' + badgeType;
          badge.dataset.menuBadgeType = badgeType;
          const translationKey = 'menuBadges' + badgeType[0].toUpperCase() + badgeType.slice(1);
          badge.querySelector('.menu-link__badge-text').textContent = menu.dataset[translationKey];
        });
      });
    })
    .catch(() => {});
})();



